import { HeaderText } from "./styled";

const Header = ({ title }) => (
    <header>
        <HeaderText>{title}</HeaderText>
    </header>
);

export default Header;